import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ProxysAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'proxy';

	getCombo() {
		let request = {
			url: [this.getAPIUrl(), 'combo'].join('/'),
		};

		return httpClient.getAsync(request);
	}

	sync() {
		let request = {
			url: [this.getAPIUrl(), 'sync'].join('/'),
		};

		return httpClient.postAsync(request);
	}

	getStat() {
		let request = {
			url: [this.getAPIUrl(), 'stats'].join('/'),
		};

		return httpClient.getAsync(request);
	}

	checkHealth() {
		let request = {
			url: [this.getAPIUrl(), 'health'].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new ProxysAPI();
